import { render, staticRenderFns } from "./DisplayValue.vue?vue&type=template&id=45efd8a5&"
import script from "./DisplayValue.vue?vue&type=script&lang=ts&"
export * from "./DisplayValue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports